'use client'

import { useEffect, useState } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import Link from 'next/link'
import Image from 'next/image'
import { Col, Row, Container, Button, Nav, Navbar, NavDropdown, Offcanvas, Modal } from 'react-bootstrap'

import MenuOne from '@/assets/menu/newspaper.webp'
import MenuTwo from '@/assets/menu/price-tag.webp'
import ArrowIcon from '@/assets/menu/arrow-icon.svg'
import ArrowIconActive from '@/assets/menu/arrow-icon-active.svg'
import useScrollListener from '@/hooks/useScrollListener'
import { LuFactory, LuRecycle, LuTruck, LuShoppingCart } from 'react-icons/lu'
import { GiTakeMyMoney } from 'react-icons/gi'
import { MdLocalPhone, MdOutlineShoppingCartCheckout } from 'react-icons/md'
import { ReactGAEvent } from '@/components/ReactGAs'
import '@/styles/css/components/header.scss'
import SearchComponent from '../components/base/SearchComponent'
import ModalSearchForm from '../components/base/SearchComponent/ModalSearchForm'
import { IoSearchOutline } from 'react-icons/io5'
import { FaPhoneAlt, FaSignInAlt } from 'react-icons/fa'

const routeName = [
	{ name: 'Buying', url: '/buying', icon: <LuShoppingCart /> },
	{ name: 'Selling', url: '/selling', icon: <MdOutlineShoppingCartCheckout /> },
	{ name: 'Metal Fabrication', url: '/metal-fabrication', icon: <LuFactory /> },
	{ name: 'Finance', url: '/finance', icon: <GiTakeMyMoney /> },
	{ name: 'Recycling', url: '/recycling', icon: <LuRecycle /> },
	{ name: 'Logistics', url: '/logistics', icon: <LuTruck /> },
]

function Header({ categoryData }) {
	const pathName = usePathname()
	const router = useRouter()
	const [navClassList, setNavClassList] = useState([])
	const scroll = useScrollListener()

	const [showOffcanvas, setShowOffcanvas] = useState(false)

	const handleClose = () => setShowOffcanvas(false)
	const handleShow = () => setShowOffcanvas(true)
	const [homePage, setHomePage] = useState(true)
	const [showSearch, setShowSearch] = useState(false)
	const [headerSearchBar, setHeaderSearchBar] = useState(false)
	const [activeModalForm, setActiveModalForm] = useState(false)

	const handleCell = (name, url = null) => {
		ReactGAEvent({ action: `${name} Nav Click`, event: 'view_page', label: 'Blank', category: name })
		url && router.push(url)
		handleClose()
	}

	const logoEventHandler = () => {
		ReactGAEvent({ action: 'Logo click', event: 'view_page', label: 'Blank', category: 'Header' })
	}

	const signInHandler = () => {
		ReactGAEvent({ action: 'Home Page View', event: 'Initiate Login', label: 'Login as buyer or supplier', category: 'Header' })
	}

	const bestFeaturesHandler = (name) => {
		handleCell(name)
	}

	useEffect(() => {
		pathName === '/' ? setHomePage(true) : setHomePage(false)
	}, [pathName])

	useEffect(() => {
		let _classList = []
		if (scroll.y > 850) {
			if (scroll.y - scroll.lastY > 0) {
				// _classList.push('nav-bar--hidden')
				_classList.push('fixed-top')
				setNavClassList(_classList)
			} else if (_classList && scroll.y - scroll.lastY < -50) {
				// _classList = []
				// setNavClassList(_classList)
			}
			setHeaderSearchBar(true)
		} else {
			pathName === '/' && _classList.push('nav-position-absolute bg-transparent')
			setNavClassList(_classList)
			setHeaderSearchBar(false)
		}
		if (showSearch && _classList.length) setShowSearch(false)
	}, [scroll.y, scroll.lastY])

	useEffect(() => {
		pathName === '/' ? setNavClassList(['nav-position-absolute bg-transparent']) : setNavClassList(['fixed-top'])
	}, [pathName])

	const checkServices = () => {
		return routeName?.find((item) => pathName.includes(item?.url)) ?? false
	}

	const arrowServicers = !homePage
		? {
				color: 'black',
		  }
		: {
				color: navClassList.find((item) => item === 'fixed-top') ? 'black' : 'white',
		  }

	const textColor = () => {
		if (homePage) {
			return navClassList.some((item) => item === 'fixed-top') ? 'text-black-50 nav-link-hover-black' : 'nav-text-logo-color nav-link-white'
		}
		return 'text-black-50 nav-link-hover-black'
	}
	const transparentHomeNav = !homePage ? 'position-sticky' : ''
	// const transparentHomeNav = homePage ? !navClassList?.length && 'nav-backgronud-dark' : ''

	return (
		<>
			{/* start recaptcha  */}
			<div id='recaptcha-container' style={{ position: 'fixed', bottom: 0, right: 0 }} />
			{/* end recaptcha  */}

			<Navbar id='navbar' expand={'md'} className={`${transparentHomeNav} ${navClassList.join(' ')} ${showSearch && 'px-0'}`}>
				<Container className='header-wapper d-flex' fluid>
					<div className='search-logo-container'>
						<div className='search-logo-wapper'>
							<Link className='d-flex align-items-center gap-2 header-logo' href='/' onClick={logoEventHandler}>
								<img src='/logo.webp' alt='metalbook' />
								<h2
									className={`logo-text  ${
										homePage && !navClassList.some((item) => item === 'fixed-top') ? 'nav-text-logo-color' : 'text-black'
									}`}
								>
									<b>METAL</b>
									<span>BOOK</span>
								</h2>
							</Link>
							<div className='search-container-item'>
								{(headerSearchBar || !homePage) && (
									<SearchComponent
										serachIcon={true}
										showSearch={showSearch}
										setShowSearch={setShowSearch}
										bannerSearch={true}
										categoryData={categoryData}
									/>
								)}
							</div>
							<div className='search-mobile-view'>
								{activeModalForm && (
									<ModalSearchForm showSearch={activeModalForm} setShowSearch={setActiveModalForm} categoryData={categoryData} />
								)}
							</div>
							<div className='d-flex align-items-center gap-2 '>
								{/* <Button variant='outline-danger' size='sm' className='px-2 py-0'> */}
								<IoSearchOutline
									className='d-block d-md-block d-lg-none d-xl-none d-xxl-none'
									size={20}
									onClick={(e) => setActiveModalForm(!activeModalForm)}
								/>
								{/* </Button> */}
								{/* <Button variant='outline-danger' size='sm' className='px-2 py-0'> */}
								<Nav.Link href='tel:+918068890535' className='d-md-none'>
									<MdLocalPhone size={20} />
								</Nav.Link>
								{/* </Button> */}
								<Navbar.Toggle
									aria-controls={`offcanvasNavbar-expand-${'md'}`}
									onClick={() => {
										handleShow()
									}}
									className='border-0 px-0'
								/>
							</div>
						</div>
					</div>
					<Navbar.Offcanvas
						id={`offcanvasNavbar-expand-${'md'}`}
						aria-labelledby={`offcanvasNavbarLabel-expand-${'md'}`}
						placement='end'
						show={showOffcanvas}
						onHide={handleClose}
					>
						<Offcanvas.Header closeButton>
							<Link
								className='d-flex align-items-center gap-2 header-logo'
								href='/'
								onClick={() => {
									handleClose()
									logoEventHandler
								}}
							>
								<img src='/logo.webp' alt='metalbook' />
								<h2 className='logo-text'>
									<b>METAL</b>
									<span>BOOK</span>
								</h2>
							</Link>
						</Offcanvas.Header>
						<Offcanvas.Body className='justify-content-between'>
							<div className='search-container'>
								<div className='search-container-nav'>
									<Nav className='offcanvas-body-nav flex-grow-1'>
										{/* <Link
										href='/'
										className={`${pathName == '/' ? 'active' : 'text-black-50'} nav-link-hover home-mobile-view`}
										onClick={() => {
											handleClose()
										}}
									>
										Home
									</Link> */}
										<NavDropdown
											title={
												<span style={{ color: '#757b8a' }} className={`${checkServices() ? 'text-dark' : textColor()}`}>
													Services
												</span>
											}
											id={`offcanvasNavbarDropdown-expand-${'md'}`}
											style={arrowServicers}
											className='arrowServicersMobile'
										>
											<Row className='d-flex header-container gx-0 shadow'>
												<Col md={5} className='row-header-left'>
													<div>
														<p className='header-title'>Core Services</p>
														<div className='mt-2'>
															{routeName?.map((item, index) => (
																<NavDropdown.Item
																	key={`${index}-${item?.url}`}
																	onClick={() => handleCell(item?.name, item?.url)}
																>
																	<Link
																		href={item?.url}
																		className={`${
																			pathName == item?.url ? 'active' : 'text-black-50'
																		} nav-link-hover-black`}
																		onClick={() => {
																			handleClose()
																		}}
																	>
																		{item.icon}
																		{item?.name}
																	</Link>
																</NavDropdown.Item>
															))}
														</div>
													</div>
												</Col>
												<Col md={7} className='d-flex'>
													<div className='row-header-right'>
														<p className='header-title'>Best Features</p>
														<NavDropdown.Item>
															<Link
																href='/blogs#news'
																onClick={() => {
																	bestFeaturesHandler('News')
																	handleClose()
																}}
																className='d-flex'
															>
																<div className='d-flex align-items-center'>
																	<Image src={MenuOne} alt='..' />
																	<div className='flex-1'>
																		<p>News</p>
																	</div>
																	<Image src={ArrowIconActive} alt='..' />
																</div>
															</Link>
														</NavDropdown.Item>
														<NavDropdown.Item>
															<Link
																href='/commodity-prices'
																onClick={() => {
																	bestFeaturesHandler('Prices')
																	handleClose()
																}}
																className='d-flex'
															>
																<div className='d-flex align-items-center'>
																	<Image src={MenuTwo} alt='..' />
																	<div className='flex-1'>
																		<p>Prices </p>
																	</div>
																	<Image src={ArrowIcon} alt='..' />
																</div>
															</Link>
														</NavDropdown.Item>
													</div>
												</Col>
											</Row>
										</NavDropdown>
										<Link
											href='/products'
											className={`${pathName.includes('products') ? 'active' : textColor()}`}
											onClick={() => {
												bestFeaturesHandler('Products')
												handleClose()
											}}
										>
											Products
										</Link>
										<Link
											href='/about-us'
											className={`${pathName.includes('about-us') ? 'active' : textColor()}`}
											onClick={() => {
												bestFeaturesHandler('About Us')
												handleClose()
											}}
										>
											About Us
										</Link>
										<Link
											href='/blogs'
											className={`${pathName.includes('blogs') ? 'active' : textColor()}`}
											onClick={() => {
												bestFeaturesHandler('Blogs')
												handleClose()
											}}
										>
											Blogs
										</Link>
										<div className='d-md-flex d-none'>
											<Nav.Link href='https://metalbook.app' target='_blank' onClick={signInHandler}>
												<Button className='border-0 py-2 px-3' size='sm'>
													<FaSignInAlt size={18} />
												</Button>
											</Nav.Link>
											<Nav.Link href='tel:+918068890535'>
												<Button size='sm' className='border-0 py-2 px-3'>
													<FaPhoneAlt size={18} />
												</Button>
											</Nav.Link>
										</div>
									</Nav>
								</div>
							</div>
							<div className='d-block d-sm-none nav-link-button'>
								<Nav.Link href='https://calendly.com/metalbook/metalbook-live-demo' target='_blank' className='sign-button'>
									<button className='border-0 btn btn-secondary w-100'>Schedule a demo</button>
								</Nav.Link>
								<Nav.Link href='https://metalbook.app' target='_blank' className='sign-button' onClick={signInHandler}>
									<Button className='border-0 w-100'>Sign In</Button>
								</Nav.Link>
								<Nav.Link href='tel:+918068890535'>
									<Button variant='outline-danger' className='w-100 rounded-5'>
										<FaPhoneAlt size={16} />
									</Button>
								</Nav.Link>
							</div>
						</Offcanvas.Body>
					</Navbar.Offcanvas>
				</Container>
				<div className={`${showSearch ? 'd-block hide-search-bar' : 'd-none'}`} onClick={() => setShowSearch(false)}></div>
			</Navbar>
		</>
	)
}

export default Header
